import styled from 'styled-components';

const Wrapper = styled.button`
  width: auto;
  padding: 0.8em 0.4em;
  background-color: ${props => props.theme.main.white};
  color: ${props => props.theme.main.primary};
  border: 1px solid ${props => props.theme.main.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    cursor: pointer;
    background-color: ${props => props.theme.main.primary};
    color: ${props => props.theme.main.white};
  }
`;

export default Wrapper;
